import { useMutation, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { AiOutlineArrowDown, AiOutlineArrowUp } from "react-icons/ai";
import { useSelector } from "react-redux";
import {
  AllData,
  EditSalesExpenseFormula,
  InvoiceTypes,
  getSalesInvoiceTypeDetailsAndItsFormula,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import Button from "../../../Components/Button/Button";
import Input from "../../../Components/Input/Input";
import PortalFooter from "../../../Components/Reactportal/PortalFooter";
import Reactportal from "../../../Components/Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../../Components/ToastComponent/RectHotToast";
import ExpensesListMapComponent from "./ExpensesListMapComponent/ExpensesListMapComponent";
import "./LinkSaleExpenses.scss";

const LinkSaleExpenses = ({ key, ParentPortalCloseFunction, show }) => {
  const { refetch } = useQuery(getSalesInvoiceTypeDetailsAndItsFormula, {
    variables: {
      id: "",
    },
  });
  const [editSalesExpenseFormula, { loading: EditSalesExpenseFormulaLoading }] = useMutation(EditSalesExpenseFormula);
  let Form_Key = "Link_Sales_Expense";
  const { data } = useQuery(AllData, {
    variables: {
      Invoice_Type: "Sales",
    },
  });
  const [toggle, settoggle] = useState(show);
  const [selected, setSelected] = useState(-1);
  const [remove, setRemove] = useState(-1);
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);

  const [invoiceType, setType] = useState("");
  const [AvailableExpenseList, setAvailableExpenseList] = useState(data ? data.SalesExpense_Formula : []);
  const [SelectedExpense, setSelectedExpenses] = useState([]);
  const LinkSalesExpensesLoadingState = EditSalesExpenseFormulaLoading ? true : false;
  useEffect(() => {
    if (data) {
      setAvailableExpenseList(data.SalesExpense_Formula);
    }
  }, [data]);

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
  };

  function handleAdd() {
    if (SelectedExpense.includes(AvailableExpenseList[selected])) {
      return;
    } else {
      setSelectedExpenses([...SelectedExpense, AvailableExpenseList[selected]]);
    }
  }
  function RemoveAll() {
    setSelectedExpenses([]);
    setRemove(-1);
  }

  function handleRemove() {
    const filterItem = SelectedExpense.filter((el, i) => i !== remove);
    setSelectedExpenses(filterItem);
  }

  function HandleUpArrow() {
    if (remove === 0 || remove === -1) {
      setRemove(remove);
    } else {
      setRemove(remove - 1);

      // Create a copy of the SelectedExpense array
      const newSelectedExpenses = [...SelectedExpense];

      // Swap the elements in the copied array
      let temp = newSelectedExpenses[remove];
      newSelectedExpenses[remove] = newSelectedExpenses[remove - 1];
      newSelectedExpenses[remove - 1] = temp;

      // Update the state with the new array
      setSelectedExpenses(newSelectedExpenses);
    }
  }

  function HandleDownArrow() {
    if (remove === SelectedExpense.length - 1 || remove === -1) {
      setRemove(remove);
    } else {
      setRemove(remove + 1);

      // Create a copy of the SelectedExpense array
      const newSelectedExpenses = [...SelectedExpense];

      // Swap the elements in the copied array
      let temp = newSelectedExpenses[remove];
      newSelectedExpenses[remove] = newSelectedExpenses[remove + 1];
      newSelectedExpenses[remove + 1] = temp;

      // Update the state with the new array
      setSelectedExpenses(newSelectedExpenses);
    }
  }

  function RemoveData(i) {
    setRemove(i);
  }

  function SelectedData(i) {
    setSelected(i);
  }

  const submit = async () => {
    let Expenses = SelectedExpense.map((el) => {
      return el._id;
    });
    await editSalesExpenseFormula({
      variables: {
        userInput: {
          SalesInvoiceType: FormDataFromRedux?.MasterData[Form_Key]?.Invoice_Type._id,
          SalesExpense_Formulas: Expenses,
        },
      },
    })
      .then((res) => {
        SuccessToast("formula created");
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };
  const SaveAndClose = () => {
    submit();
    Closeformfunction();
  };
  const getExpensdeList = async () => {
    if (FormDataFromRedux?.MasterData[Form_Key]?.Invoice_Type._id) {
      refetch({ id: FormDataFromRedux?.MasterData[Form_Key]?.Invoice_Type._id })
        .then((res) => {
          setSelectedExpenses(
            res.data.getLinkSalesExpense_With_Populate_Details_By_SalesInvoiceType[0].SalesExpense_Formulas
          );
        })
        .catch((error) => {
          setSelectedExpenses([]);
          // ErrorToast(error.message);
        });
    } else {
      ErrorToast("Select an Invoice Type First");
    }
  };
  return (
    <>
      <div key={key} className="LinkSaleMainDiv">
        <Reactportal
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={"Link Sales Expense Formulas With Invoice Type"}
          TypeOfId={"Account Id :"}
        >
          <div className="LinkSaleExpenses_MainDiv">
            <div className="SelectInvoiceType_div">
              <div className="inpDiv">
                <Input
                  EMTQuery=""
                  checked={""}
                  InputConfig={{
                    masterName: "SalesInvoiceType",
                    variable: {
                      Invoice_Type: "Sales",
                    },
                  }}
                  value={invoiceType}
                  type="InputDropForQuery"
                  name="Invoice_Type"
                  dropdowndata={InvoiceTypes}
                  handleBlur={() => {}}
                  label={"Select Invoice Type"}
                  modalform={true}
                  Iconinside={true}
                  transactions={true}
                  TypeOfPortal={"Link Expense With Invoice Type"}
                  handleInputChange={(e) => {
                    if (e.target.value) {
                      setType(e.target.value);
                    }
                  }}
                  Tax_Type={true}
                  formkey={Form_Key}
                />
              </div>
              <Button name="getExpenses" text="Get Expense List" action={getExpensdeList}></Button>
            </div>
            <div className="LinkSaleExpenses_subdiv">
              <ExpensesListMapComponent
                value={AvailableExpenseList}
                name={"Available Expense List"}
                Setfunction={SelectedData}
                HighlightData={selected}
              />

              <div className="MiddleDiv">
                <div className="MiddleDiv_subdiv">
                  <Button name="getExpenses1" text="Add" action={handleAdd} />
                  <div className="Arrows_Div">
                    <AiOutlineArrowUp size={30} onClick={HandleUpArrow} />
                    <br />
                    <AiOutlineArrowDown size={30} onClick={HandleDownArrow} />
                  </div>
                  <Button name="getExpenses1" text="Remove" action={handleRemove} />
                  <Button name="getExpenses1" text="Remove All" action={RemoveAll}></Button>
                </div>
              </div>

              <ExpensesListMapComponent
                value={SelectedExpense}
                name={"Selected Expense"}
                Setfunction={RemoveData}
                HighlightData={remove}
              />
            </div>
            <p className="SelectedExpenses">Selected Expense : {SelectedExpense.length}</p>
          </div>

          <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            submitform={submit}
            SaveAndClose={SaveAndClose}
            handleformclose={() => {
              Closeformfunction();
              settoggle(!toggle);
            }}
            submitType={"Save"}
            loadingState={LinkSalesExpensesLoadingState}
          />
        </Reactportal>
      </div>
    </>
  );
};

export default LinkSaleExpenses;
